import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { NgfFormControl } from '@ng-falcon/ngf-form/+model/ngf-form-control';
import { NgfFormGroup } from '@ng-falcon/ngf-form/+model/ngf-form-group';
import { TextEditorTemplate } from '../+model/text-editor-template.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Validators } from '@angular/forms';
import { TextEditorSelectionEvent } from '../+model/text-editor-selection-event.model';
import { Subscription, tap } from 'rxjs';

export interface TextEditorTemplateSelectDialogData {
  templates: TextEditorTemplate[];
}

@Component({
    selector: 'ngf-text-editor-template-select-dialog',
    templateUrl: './text-editor-template-select-dialog.component.html',
    styleUrls: ['./text-editor-template-select-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextEditorTemplateSelectDialogComponent implements OnInit {

  private sub = Subscription.EMPTY;

  form = new NgfFormGroup({
    template: new NgfFormControl<TextEditorTemplate>(null, {validators: Validators.required}),
    replaceText: new NgfFormControl<boolean>(true)
  })

  constructor(private dialogRef: MatDialogRef<TextEditorTemplateSelectDialogComponent, TextEditorSelectionEvent>,
              @Inject(MAT_DIALOG_DATA) public readonly data: TextEditorTemplateSelectDialogData) {}

  ngOnInit(): void {
    this.sub = this.form.controls.template.value$.pipe(
      tap(template => {
        // template may define that it
        // should not replace actual text
        // by default
        if (this.form.controls.replaceText.value && template?.amendByDefault) {
          this.form.controls.replaceText.setValue(false);
        }
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  selectTemplate() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    } else {
      this.dialogRef.close({template: this.form.value.template, replaceSelection: this.form.value.replaceText === true })
    }
  }



}
